// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Incident API
 * API to get incident information
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  HandlerErrorResponse,
  HandlerIncidentListResponse,
} from '../models/index';
import {
  HandlerErrorResponseFromJSON,
  HandlerErrorResponseToJSON,
  HandlerIncidentListResponseFromJSON,
  HandlerIncidentListResponseToJSON,
} from '../models/index';

export interface V1IncidentsGetRequest {
  activeOnly?: boolean;
  dbid?: string;
  dbmsClusterId?: string;
}

/**
 *
 */
export class InternalApi extends runtime.BaseAPI {
  /**
   * Ensure the API and database connection is active and healthy.
   * API and database Health Check
   */
  async pingGetRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<{ [key: string]: string }>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/ping`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Ensure the API and database connection is active and healthy.
   * API and database Health Check
   */
  async pingGet(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<{ [key: string]: string }> {
    const response = await this.pingGetRaw(initOverrides);
    return await response.value();
  }

  /**
   * listing of incidents
   * listing of incidents
   */
  async v1IncidentsGetRaw(
    requestParameters: V1IncidentsGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<HandlerIncidentListResponse>> {
    const queryParameters: any = {};

    if (requestParameters['activeOnly'] != null) {
      queryParameters['active-only'] = requestParameters['activeOnly'];
    }

    if (requestParameters['dbid'] != null) {
      queryParameters['dbid'] = requestParameters['dbid'];
    }

    if (requestParameters['dbmsClusterId'] != null) {
      queryParameters['dbms_cluster_id'] = requestParameters['dbmsClusterId'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/v1/incidents`;

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      HandlerIncidentListResponseFromJSON(jsonValue),
    );
  }

  /**
   * listing of incidents
   * listing of incidents
   */
  async v1IncidentsGet(
    requestParameters: V1IncidentsGetRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<HandlerIncidentListResponse> {
    const response = await this.v1IncidentsGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
